var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading__img",class:_vm.spinners[Math.floor(Math.random() * 7)]}),_c('p',{staticClass:"loading__text"},[_vm._v("loading ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }